import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { SortAlphaDown, SortAlphaDownAlt, SortDown, SortDownAlt } from "react-bootstrap-icons";

export default function SearchOrder() {
  const [search, setSearch] = useSearchParams();
  const [Icon, setIcon] = useState(() => SortDown);

  useEffect(() => {
    const sortby = search.get("sortby");
    const orderby = search.get("orderby");
    if (sortby) {

      if (sortby === "isodate") {
        setIcon(orderby === "asc" ? SortDown : SortDownAlt);
      } else if (sortby === "sorttitle") {
        setIcon(orderby === "asc" ? SortAlphaDown : SortAlphaDownAlt);
      }
    }else{
      setIcon(SortDown);
    }
  }, [search]);

  const toggleOrder = () => {
    const current = search.get("orderby");
    const next = current === "asc" ? "desc" : "asc";
    search.set("orderby", next);
    setSearch(search); // actualiza la URL
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", alignItems: "center", height: "100%" }}>
      <div onClick={toggleOrder} style={{ cursor: "pointer" }}>
        <Icon size={25} />
      </div>
    </div>
  );
}